import type { ReactNode, MouseEvent } from 'react';
import Box, { BoxProps } from '@mui/material/Box';
import type { Children } from '@repo/shared/types';
import p24LogoUrl from '@repo/assets/images/przelewy-24-logo.svg?url';
import { Breadcrumbs } from '@repo/ui';

interface LiberisStageWrapper extends Children {
  title: ReactNode;
  titleWrapperSx?: BoxProps['sx'];
  iconWrapperSx?: BoxProps['sx'];
  contentSx?: BoxProps['sx'];
  isVerticalHeader?: boolean;
  onBackButtonClick?: () => void;
}

export function LiberisStageWrapper({
  children,
  title,
  titleWrapperSx,
  iconWrapperSx,
  contentSx,
  isVerticalHeader = false,
  onBackButtonClick,
}: LiberisStageWrapper) {
  const handleBackButtonClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    if (onBackButtonClick) {
      onBackButtonClick();
    }
  };

  return (
    <>
      {onBackButtonClick ? <Breadcrumbs onClick={(event) => handleBackButtonClick(event)} /> : null}
      {isVerticalHeader ? (
        <Box
          sx={{
            marginBottom: { xs: '14px', sm: '6px', md: '30px' },
            paddingLeft: { xs: '10px', sm: '16px', md: '20px', xl: '40px' },
            ...titleWrapperSx,
          }}
        >
          <Box
            sx={{
              marginBottom: { xs: '14px', sm: '6px', md: '28px' },
              ...iconWrapperSx,
            }}
          >
            <Box component="img" src={p24LogoUrl} alt="p24 logo" height={60} />
          </Box>
          {title}
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            ...titleWrapperSx,
          }}
        >
          {title}
          <Box
            sx={{
              marginBottom: { xs: '14px', sm: '6px', md: '28px' },
              position: 'absolute',
              right: { xs: '10px', md: '20px', xl: '30px' },
              ...iconWrapperSx,
            }}
          >
            <Box component="img" src={p24LogoUrl} alt="p24 logo" height={40} />
          </Box>
        </Box>
      )}

      <Box sx={contentSx}>{children}</Box>
    </>
  );
}
